import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DatasetListingService } from 'src/app/dataset-listing/dataset-listing.service';
import { AdminService } from '../../admin/admin.service';
import { SnackbarService } from 'src/app/core/snackbar.service';
import { Category } from '@models/mood/covariates/category';
import { TreeGeneratorService } from 'src/app/core/datasets/tree-generator.service';
import { GroupedTreeNode } from 'src/app/core/datasets/tree.interface';
import { MatRadioChange } from '@angular/material/radio';

interface CategoryForm {
  label: FormControl<string | null>;
  parent_id: FormControl<string | null>;
  order: FormControl<number | null>;
  sort_by_name: FormControl<boolean | null>;
}

@Component({
  selector: 'mood-category-edit-form',
  templateUrl: './category-edit-form.component.html',
  styleUrls: [
    'category-edit-form.component.scss'
  ]
})
export class CategoryEditFormComponent implements OnInit {
  private _category!: Category;
  @Input() set category(value: Category) {
    this._category = value;

    this._updateExistingValues();
  };

  public get category() {
    return this._category;
  }


  categoryForm: FormGroup<CategoryForm>;
  categoryList!: Category[];
  categoryTreeList!: GroupedTreeNode[];

  constructor(
    private _snackbarService: SnackbarService,
    private _dataListingService: DatasetListingService,
    private _treeService: TreeGeneratorService,
    private _changeRef: ChangeDetectorRef,
    private _adminService: AdminService) {

    this.categoryForm = new FormGroup<CategoryForm>({
      label: new FormControl<string | null>(null, [Validators.required]),
      parent_id: new FormControl<string | null>(null),
      order: new FormControl<number | null>(null),
      sort_by_name: new FormControl<boolean | null>(null)
    });
  }

  public get currentParentCategory() {
    return this.categoryForm.get('parent_id')!.value!;
  }

  get saveButtonDisabled() {
    return this.categoryForm.invalid || this.categoryForm.pristine;
  }

  private _updateExistingValues() {
    this.categoryForm.reset();

    this.categoryForm.patchValue(this.category);

    this.categoryForm.markAsPristine();

    if (!this.category.parent_id) {
      this.categoryForm.patchValue({ parent_id: null });
    }
  }

  public updateParentCategory(value?: string) {
    this.categoryForm.patchValue({ parent_id: value });
    this.categoryForm.markAsDirty();
  }

  async ngOnInit() {
    this._adminService.categoryUpdated.subscribe(async _ => {
      await this._generateTree();
    });

    await this._generateTree();
  }

  private async _generateTree() {
    this.categoryList = await this._dataListingService.getDatasetCategories();
    this.categoryTreeList = this._treeService.createCategoryTree(this.categoryList);

    this._changeRef.markForCheck();
  }

  public get isRootChecked() {
    return this.currentParentCategory === null;
  }

  public selectionChanged(event: MatRadioChange) {
    this.updateParentCategory(event.value);
  }

  async saveForm() {
    // TODO: Handle failure
    if (this.categoryForm.valid) {
      this.category = await this._adminService.updateDataCategory(this.category.id, this.categoryForm.getRawValue() as Category);

      await this._dataListingService.updateDatasetCategoryByid(this.category.id, this.category);


      this._adminService.categoryUpdated.emit();

      this.categoryForm.markAsPristine();

      this._snackbarService.openSuccessMessage("Category updated");
    }
  }
}
